<template>
    <div>
        <b-modal
            id="feedbacksLayerChoiceModal"
            :dialog-class="{ measure: isTypeMeasurement }"
            :visible="true"
            no-close-on-esc
            no-close-on-backdrop
            no-fade
            hide-footer
            hide-header
        >
            <!-- Header -->
            <div class="panel-header">
                <h3 class="panel-header-title">{{ modalTitle }}</h3>
                <!-- Close icon -->
                <icon-close
                    :id="'feedbacksClose'"
                    @close="$emit('cancel')"
                    class="d-inline-block float-right"
                >
                </icon-close>
            </div>
            <!-- Content -->
            <div class="feedback-content">
                <b-form
                    id="feedback-form"
                    name="feedback-form"
                    enctype="multipart/form-data"
                    v-on:submit.prevent="$emit('selected', feedbackSelected)"
                >
                    <!-- Dropdown list -->
                    <x-select
                        :name="'slcFeedbacks'"
                        :options="feedbackOptions"
                        v-model="feedbackSelected"
                        :required="true"
                        :simpleMode="true"
                    />
                    <!-- Buttons -->
                    <div id="feedback-buttons">
                        <b-button variant="primary" type="submit">
                            <span>OK</span>
                        </b-button>
                        <b-button @click="$emit('cancel')">
                            <span>{{ $t('btnCancelLabel') }}</span>
                        </b-button>
                    </div>
                </b-form>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import {
        CONTENT_TYPE_ID,
        INTERFACE_PANEL_TRIGGERS
    } from '../../../../constants';

    import { mapState } from 'vuex';
    import IconClose from '../../../IconClose.vue';

    export default {
        name: 'Feedbacks',

        components: { 'icon-close': IconClose },
        props: {
            feedbackId: { type: Number, default: null },
            contentTypeId: { type: Number, required: true },
            feedbackOptions: { type: Array, required: true }
        },

        data() {
            return { feedbackSelected: this.feedbackId };
        },

        computed: {
            ...mapState(['uiElements']),
            feedbackPanel: function () {
                return this.uiElements[INTERFACE_PANEL_TRIGGERS.FEEDBACK_EDIT];
            },

            modalTitle() {
                if (this.isTypeMeasurement) {
                    return this.$t('menuItemMeasurements');
                } else {
                    return this.$t('menuItemFeedbacks');
                }
            },

            isTypeMeasurement() {
                return this.contentTypeId === CONTENT_TYPE_ID.MEASUREMENT;
            }
        }
    };
</script>

<style lang="scss">
#feedbacksLayerChoiceModal .modal-dialog {
    position: absolute;
    margin: 0px;
    top: $menu-bar-height;
    min-height: 40px;
    min-width: 300px;
    max-width: 300px;
}

/*-------------------------------------
    max-width : 500px
    ---------------------------------------*/
@media (max-width: 500px) {
    #feedbacksLayerChoiceModal .modal-dialog {
        right: 0;
        left: auto !important;
    }
}

/*-------------------------------------
    min-width : 500px
    ---------------------------------------*/
@media (min-width: 500px) {
    #feedbacksLayerChoiceModal .modal-dialog {
        left: calc(50% - 45px);

        &.measure {
            left: calc(50% - 5px);
        }
    }
}

#feedbacksLayerChoiceModal .modal-dialog .modal-content {
    border: none;
    border-radius: initial;
}

#feedbacksLayerChoiceModal .modal-body {
    padding: 0px;
}
</style>

<style scoped>
.feedback-content {
    padding: 20px;
}

#feedback-buttons {
    display: flex;
    justify-content: flex-end;
}

#feedback-buttons > button:first-child {
    margin-right: 3px;
}
</style>
